import { getDeviceDate } from "@myvp/shared/src/clock/get-device-date"

/**
 * Calling this function will cause any tab on a page wrapped in a UserProvider to
 * refresh and update the user metadata
 */
export const refreshOpenTabs = () => {
  localStorage.setItem("myvp-refresh", getDeviceDate().getTime().toString())
}
